export { ArrowRightIcon } from "./arrow-right";
